import React, { useEffect } from 'react';
import WebFont from 'webfontloader';
import { ChevronRight as ArrowRight, Check } from '@mui/icons-material';
import { useTheme, styled } from '@mui/system';
import Text from '../Text.js';
import Tooltip from '../Tooltip.js';
import { colors } from '../../theme/index.js';

/**
 *
 * @param {*} param0
 */
const StepTile = ({
  step,
  onClick,
  completed,
  title,
  description,
  whitelabel = {},
  tooltip = {},
  disabled,
  customStyle,
  id,
  testid
}) => {
  const theme = useTheme();
  const StyledContainer = styled('div')({
    flex: 1,
    boxShadow: disabled ? "none" : '0px 1px 3px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: "24px 32px",
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      boxShadow: disabled ? "none" : '0px 12px 40px rgba(0, 0, 0, 0.15)'
    },
    zIndex: 2,
    height: 100,
    background: colors.surface,
    ...customStyle
  });
  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Material Icons']
      }
    });
  }, []);
  const styles = {
    disabledOverlay: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      background: 'rgba(232, 232, 232, 0.6)',
      marginLeft: -32
    },
    digitContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 0.5
    },
    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 0.5
    },
    digitCircle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 30,
      height: 30,
      borderRadius: 50,
      backgroundColor: disabled ? colors.darkGrey : theme.palette.primary.main
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flex: 5,
      padding: '0 20px',
      width: '100%'
    },
    icon: {
      color: '#FFF',
      fontSize: 20
    }
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    tip: (disabled || tooltip.alwaysShow) && tooltip.tip,
    arrow: true,
    placement: tooltip.position
  }, /*#__PURE__*/React.createElement(StyledContainer, {
    id: id || testid,
    onClick: disabled || !onClick ? null : onClick
  }, disabled && /*#__PURE__*/React.createElement("div", {
    style: styles.disabledOverlay
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.digitContainer
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.digitCircle
  }, completed ? /*#__PURE__*/React.createElement(Check, {
    style: styles.icon
  }) : /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    color: colors.surface
  }, step))), /*#__PURE__*/React.createElement("div", {
    style: styles.textContainer
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    color: colors.darkGrey,
    display: "block",
    align: "left"
  }, title), /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true,
    display: "block",
    align: "left",
    color: colors.darkGrey,
    customStyle: {
      width: "100%",
      wordBreak: "break-word"
    }
  }, description)), /*#__PURE__*/React.createElement("div", {
    style: styles.iconContainer
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    style: {
      color: '#000',
      fontSize: 30
    }
  })))));
};
export default StepTile;